import { ExportReportOptions, ReportForExport } from '../../../apis/graphql/reports/types';
import { useGenerateReportFileUrl } from '../../../apis/graphql/reports/useGenerateReportFileUrl';
import admanToast from '../../../components/Alert/util/admanToast';
import { downloadFile } from '../../../utils/download';

type UseExportReport = {
  download: (report: ReportForExport, options?: ExportReportOptions) => Promise<void>;
  loading: boolean;
};

const useExportReport = (defaultName?: string): UseExportReport => {
  const { generate, loading } = useGenerateReportFileUrl();

  const handleDownload = async (report: ReportForExport, options?: ExportReportOptions): Promise<void> => {
    const filename = report.name || defaultName || 'Report';
    try {
      const url = await generate(report, options);

      if (!url) {
        admanToast.error(`There was an error generating ${filename}`);
        return;
      }

      const regex = /\/([^/?#]+)(\.\w+)(\?|$)/;
      const matches = url.match(regex);
      const filenameWithExtension = matches ? decodeURIComponent(matches[1] + matches[2]) : filename;

      await downloadFile(
        url,
        () => {
          admanToast.error(`There was an error exporting ${filename}`);
        },
        filenameWithExtension
      );
      admanToast.success(`${filename} Successfully exported`);
    } catch (error) {
      admanToast.error(`There was an error exporting ${filename}`);
    }
  };

  return {
    download: handleDownload,
    loading,
  };
};

export default useExportReport;
